import { RegionListItem } from '../../../../../pages/admin-dashboard/region-view-list/list-of-regions/list-of-regions.model';

export const mapRegionsToTableRows = (regions: RegionListItem[], isArabic: boolean) => {
  return regions.map((r) => ({
    id: r.id,
    rawEntity: r,
    title: isArabic ? r.titleAr || r.titleEn : r.titleEn || r.titleAr,
    intervals: r.numberOfIntervals !== null ? r.numberOfIntervals : '—',
    createdOn: r.createdOn,
    createdBy: r.createdBy?.fullName || '—',
    lastModifiedOn: r.lastModifiedOn,
    lastModifiedBy: r.lastModifiedBy?.fullName || '—',
  }));
};
